import axios from "axios";
import Raven from "raven-js";
import { isTestServer, isDevEnv } from "./utils";

export const serverUrl =
  process.env.NODE_ENV !== "production"
    ? "https://gdt.test.evidenceprime.com/_api"
    : `${window.location.origin}/_api`;

export const axiosInstance = axios.create({
  baseURL: serverUrl,
  withCredentials: true
});

export const handleApiError = error => {
  if (isDevEnv() || isTestServer()) {
    console.warn(error);
  }
  if (!isDevEnv()) sendReportToSentry(error);
};

export const sendReportToSentry = error => Raven.captureException(error);
